export default __webpack_public_path__ + "static/media/@lijoane.9411e872.jpg";